import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/*
|--------------------------------------------------------------------------
| ROLES — Staff Portal
|--------------------------------------------------------------------------
*/

export const getRolesForPortal = async () => {
  const { data } = await axiosInstance.get("/staff-portal/roles");
  return data;
};

/*
|--------------------------------------------------------------------------
| STAFF — Staff Portal
|--------------------------------------------------------------------------
*/

export const getAllStaffForStaff = async () => {
  const { data } = await axiosInstance.get("/staff-portal/all");
  return data;
};

export const getStaffByIdForStaff = async (id) => {
  const { data } = await axiosInstance.get(`/staff-portal/${id}`);
  return data;
};

export const createStaffForPortal = async (formData) => {
  const { data } = await axiosInstance.post("/staff-portal/create", formData);
  return data;
};

export const updateStaffForPortal = async (id, formData) => {
  const { data } = await axiosInstance.put(`/staff-portal/update/${id}`, formData);
  return data;
};

export const toggleStaffStatusForPortal = async (id) => {
  const { data } = await axiosInstance.put(`/staff-portal/status/${id}`);
  return data;
};

export const resetStaffPasswordForPortal = async (id) => {
  const { data } = await axiosInstance.put(`/staff-portal/reset-password/${id}`);
  return data;
};

/*
|--------------------------------------------------------------------------
| MY PROFILE — Staff self-update
|--------------------------------------------------------------------------
*/

export const updateMyProfile = async (formData) => {
  const { data } = await axiosInstance.put("/staff-portal/my-profile", formData);
  return data;
};